import React from "react";
import { Link } from "gatsby";

import { FiFacebook } from "react-icons/fi";
import { FiYoutube } from "react-icons/fi";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";

import MountainDivider from "./mountains";

export default function Footer() {
  return (
    <footer>
      <MountainDivider
        className="mountain-divider"
        flip={0}
        iterations={8}
        roughness={0.8}
        height={3}
      />
      <nav className="footer-menu">
        <ul className="">
          <li>
            <Link
              activeClassName="active"
              className="underline-onhover"
              partiallyActive={true}
              to="/category/anouncements/"
            >
             Anouncements
            </Link>
          </li>
          <li>
            <Link
              activeClassName="active"
              className="underline-onhover"
              partiallyActive={true}
              to="/code-of-ethics/"
            >
              Code of Ethics
            </Link>
          </li>
          <li>
            <Link
              activeClassName="active"
              className="underline-onhover"
              partiallyActive={true}
              to="/glossary-and-guidelines/"
            >
              Glossary and Guidelines
            </Link>
          </li>
          <li>
            <Link
              activeClassName="active"
              className="underline-onhover"
              partiallyActive={true}
              to="/citation-guidelines-for-authors-and-editors/"
            >
              Citation Guidelines
            </Link>
          </li>
          <li>
            <Link
              activeClassName="active"
              className="underline-onhover"
              partiallyActive={true}
              to="/for-contributors/"
            >
              For Contributors
            </Link>
          </li>
          {/* <li>
              <Link
                activeClassName="active"
                className="underline-onhover"
                partiallyActive={true}
                to="/comment-policy/">
                Comment Policy
              </Link>

            </li> */}
          <li>
            <Link
              activeClassName="active"
              className="underline-onhover"
              partiallyActive={true}
              to="/about-us/"
            >
              About Us
            </Link>
          </li>
          <li>
            <Link
              activeClassName="active"
              className="underline-onhover"
              partiallyActive={true}
              to="/contact-us/"
            >
              Contact Us
            </Link>
          </li>
          <li className="footer-social">
            <ul className="social">
              <li className="">
                <a
                  className="with-icons"
                  aria-label="facebook link"
                  href="https://www.facebook.com/journalofconflicttransformation"
                >
                  <FiFacebook />
                </a>
              </li>
              <li className="">
                <a
                  className="with-icons"
                  aria-label="twitter link"
                  href="https://x.com/CaucasusEdition"
                >
                  <FaXTwitter />
                </a>
              </li>
              <li className="">
                <a
                  className="with-icons"
                  aria-label="instagramm link"
                  href="https://www.instagram.com/caucasusedition"
                >
                  <FaInstagram />
                </a>
              </li>
              <li>
                <a
                  className="with-icons"
                  aria-label="youtube link"
                  href="https://www.youtube.com/@caucasusedition304"
                >
                  <FiYoutube />
                </a>
              </li>
            </ul>
          </li>
        </ul>
        {/* <ul className="social with-icons"> */}

        {/* </ul> */}
      </nav>
      <p className="footer-disclaimer">
        All rights reserved. Full or partial reproduction of materials is
        allowed only with a reference to the Journal of Conflict Transformation
        as the source.
      </p>
      <p className="footer-disclaimer">© 2010-2023 Caucasus Edition.</p>
    </footer>
  );
}
